export default __webpack_public_path__ + "static/media/arcade_logo.aef096d6.jpeg";